export default __webpack_public_path__ + "static/media/rowlet.31d49f97.png";